(() => {
  const translations = {
    uk: 'Купити в 1 клік',
    ru: 'Купить в 1 клик',
  };

  const resolveLocale = () => {
    const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    const shopifyLocale = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : '').toLowerCase();
    const locale = htmlLang || shopifyLocale;

    if (locale.startsWith('uk')) return 'uk';
    if (locale.startsWith('ru')) return 'ru';
    return null;
  };

  const locale = resolveLocale();
  if (!locale) return;

  const label = translations[locale];
  const selector = '.shopify-payment-button__button--unbranded, .shopify-payment-button__button';

  const updateButtons = (root = document) => {
    root.querySelectorAll(selector).forEach((button) => {
      if (button.classList.contains('shopify-payment-button__button--branded')) return;
      if (button.textContent && button.textContent.trim() !== label) {
        button.textContent = label;
      }
    });
  };

  const updateIframeButtons = () => {
    document.querySelectorAll('iframe').forEach((iframe) => {
      try {
        if (!iframe.contentDocument) return;
        updateButtons(iframe.contentDocument);
      } catch (error) {
      }
    });
  };

  const apply = () => {
    updateButtons(document);
    updateIframeButtons();
  };

  const scheduleApply = () => {
    requestAnimationFrame(apply);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApply);
  } else {
    scheduleApply();
  }

  window.addEventListener('load', scheduleApply);

  const observer = new MutationObserver(() => {
    scheduleApply();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const interval = setInterval(() => {
    attempts += 1;
    apply();
    if (attempts >= 20) {
      clearInterval(interval);
    }
  }, 500);
})();
